import Footer from '../components/Footer'
import Header from '../components/Header'
import Canvas from '../components/Canvas'
import { Helmet } from 'react-helmet'
import { useEffect, useContext } from 'react'
import { LoadingContext } from '../App'

const About = () => {
    const { setIsPageReady } = useContext(LoadingContext);

    useEffect(() => {
        setIsPageReady(true);
    }, [setIsPageReady]);

    return (
        <>
            <Helmet>
                <title>About Us | Sacesta Technologies</title>
                <meta name="description" content="Learn more about Sacesta Technologies, our story, and our mission to provide top-tier software development and innovative digital solutions." />
                <link rel="canonical" href="https://sacesta.com/about" />
            </Helmet>
            <div className="cursor1"></div>
            <div className="cursor2"></div>

            {/* <!-- Team Cursor --> */}
            <div className="cursor" id="team_cursor">Drag</div>




            {/* <!-- Scroll Smoother --> */}
            <div className="has-smooth" id="has_smooth"></div>


            {/* <!-- Go Top Button --> */}
            <button id="scroll_top" className="scroll-top"><i className="fa-solid fa-arrow-up"></i></button>


            {/* <!-- Header area start --> */}
            {/* <?php include "includes/header.php"; ?> */}
            <Header />
            {/* <!-- Header area end --> */}


            {/* <?php include "includes/canvas.php" ?> */}
            <Canvas />


            <div id="smooth-wrapper">
                <div id="smooth-content">
                    <main>

                        {/* <!-- Hero area start --> */}
                        <section className="hero__about">
                            <div className="container g-0 line">
                                <span className="line-3"></span>
                                <div className="row">
                                    <div className="col-xxl-12">
                                        <div className="hero__about-content">
                                            <h1 className="hero-title animation__word_come">Driving your business forward with Sacesta Technologies' innovative software development solutions.</h1>
                                            <div className="hero__about-info">
                                                <div className="hero__about-btn">
                                                    <div className="btn_wrapper">
                                                        <a href="https://www.linkedin.com/company/sacesta/"
                                                            className="wc-btn-primary btn-hover btn-item"><span></span> Service Page
                                                            <br /> LinkedIn
                                                            <i className="fa-solid fa-arrow-right"></i></a>
                                                    </div>
                                                </div>
                                                <div className="hero__about-text title-anim">
                                                    <p>Sacesta Technologies: Your go-to for all things digital. We focus on making software, designing, and boosting your brand. Let's take your online look to the next level today.</p>
                                                </div>
                                                {/* <!-- <div className="hero__about-award">
                                                        <img src="assets/imgs/about/award.png" alt="Best Studio Award">
                                                    </div> --> */}

                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row hero__about-row">
                                    <div className="col-xxl-12">
                                        <div className="hero__about-video">
                                            <video loop muted autoPlay playsInline>
                                                <source src="assets/video/video.mp4" type="video/mp4" />
                                            </video>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                        {/* <!-- Hero area end --> */}


                        {/* <!-- Story area start --> */}
                        <section className="story__area">
                            <div className="container g-0 line pt-140">
                                <span className="line-3"></span>
                                <div className="sec-title-wrapper">


                                    <div className="row">
                                        <div className="col-xxl-5 col-xl-5 col-lg-5 col-md-5">
                                            <h2 className="sec-sub-title title-anim">Development House</h2>
                                            <h3 className="sec-title title-anim">Our story</h3>
                                        </div>
                                        <div className="col-xxl-7 col-xl-7 col-lg-7 col-md-7">
                                            <div className="story__text">
                                                <p>At Sacesta Technologies, we are not just a software development company; we are your technology partner. We collaborate with you to conceptualize, design, and build tailored software solutions that drive efficiency, competitiveness, and growth. Whether you require a custom application, a sophisticated web platform, or a mobile app, we have the knowledge and experience to deliver solutions that exceed expectations.

                                                </p>
                                                <p>Our team of dedicated professionals shares a passion for innovation, problem-solving, and delivering results. We are committed to providing top-tier software development services that help you achieve your business goals while staying at the forefront of technological advancements.</p>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3">
                                        <div className="story__img-wrapper">
                                            <img src="assets/imgs/story/3.jpg" alt="Story Thumbnail" className="w-100" />
                                        </div>
                                    </div>
                                    <div className="col-xxl-5 col-xl-5 col-lg-5 col-md-5">
                                        <div className="story__img-wrapper img-anim">
                                            <img src="assets/imgs/story/1.png" alt="Story Thumbnail" data-speed="auto" />
                                        </div>
                                    </div>
                                    <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4">
                                        <div className="story__img-wrapper">
                                            <img src="assets/imgs/story/3.jpg" alt="Story Thumbnail" />
                                            <img src="assets/imgs/story/4.png" alt="Story Thumbnail" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                        {/* <!-- Story area end --> */}


                        {/* <!-- Counter area start --> */}
                        <section className="counter__area">
                            <div className="container g-0 line pb-140 pt-140">
                                <span className="line-3"></span>

                                <div className="row">
                                    <div className="col-xxl-12">
                                        <div className="counter__wrapper-2 counter_animation">
                                            <div className="counter__item-2 counter__anim">
                                                <h2 className="counter__number">41+</h2>
                                                <p>Features <br />Planned</p>
                                                <span className="counter__border"></span>
                                            </div>
                                            <div className="counter__item-2 counter__anim">
                                                <h2 className="counter__number">900+</h2>
                                                <p>Hours of <br />Creation</p>
                                                <span className="counter__border"></span>
                                            </div>
                                            <div className="counter__item-2 counter__anim">
                                                <h2 className="counter__number">890+</h2>
                                                <p>Lines of <br />code daily</p>
                                                <span className="counter__border"></span>
                                            </div>
                                            <div className="counter__item-2 counter__anim">
                                                <h2 className="counter__number">1200+</h2>
                                                <p>Work <br />Hours</p>
                                                <span className="counter__border"></span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                        {/* <!-- Counter area end --> */}





                        {/* <!-- Brand area start --> */}
                        <section className="brand__area">
                            <div className="container g-0 line pt-140 pb-140">
                                <span className="line-3"></span>
                                <div className="row g-0">
                                    <div className="col-xxl-12">
                                        <div className="sec-title-wrapper">
                                            <h2 className="sec-sub-title title-anim"> Brands</h2>
                                            <h3 className="sec-title title-anim">Our Esteemed Collaborators</h3>
                                        </div>
                                    </div>

                                    <div className="brand__list">
                                        <div className="brand__item fade_bottom">
                                            <img src="assets/imgs/brand/1.png" alt="Brand Logo" />
                                        </div>
                                        <div className="brand__item fade_bottom">
                                            <img src="assets/imgs/brand/2.png" alt="Brand Logo" />
                                        </div>
                                        <div className="brand__item fade_bottom">
                                            <img src="assets/imgs/brand/3.png" alt="Brand Logo" />
                                        </div>
                                        <div className="brand__item fade_bottom">
                                            <img src="assets/imgs/brand/4.png" alt="Brand Logo" />
                                        </div>
                                        <div className="brand__item fade_bottom">
                                            <img src="assets/imgs/brand/5.png" alt="Brand Logo" />
                                        </div>
                                        <div className="brand__item fade_bottom">
                                            <img src="assets/imgs/brand/6.png" alt="Brand Logo" />
                                        </div>
                                        {/* <!-- <div className="brand__item fade_bottom">
                                                <img src="assets/imgs/brand/7.png" alt="Brand Logo" />
                                            </div>
                                            <div className="brand__item fade_bottom">
                                                <img src="assets/imgs/brand/8.png" alt="Brand Logo" />
                                            </div>
                                            <div className="brand__item fade_bottom">
                                                <img src="assets/imgs/brand/9.png" alt="Brand Logo" />
                                            </div>
                                            <div className="brand__item fade_bottom">
                                                <img src="assets/imgs/brand/10.png" alt="Brand Logo" />
                                            </div> --> */}
                                    </div>
                                </div>
                            </div>
                        </section>
                        {/* <!-- Brand area end --> */}


                        {/* <!-- Testimonial area start --> */}
                        <section className="testimonial__area-2">
                            <div className="container g-0 line pb-140">
                                <span className="line-3"></span>

                                <div className="row g-0">
                                    <div className="col-xxl-5 col-xl-5 col-lg-5 col-md-5">
                                        <div className="testimonial__video">
                                            <video autoPlay muted loop>
                                                <source src="assets/video/testimonial.mp4" type="video/mp4" />
                                            </video>
                                        </div>
                                    </div>

                                    <div className="col-xxl-7 col-xl-7 col-lg-7 col-md-7">
                                        <div className="testimonial__slider-wrapper-2">
                                            <div className="swiper testimonial__slider">
                                                <div className="swiper-wrapper">

                                                    <div className="swiper-slide testimonial__slide">
                                                        <div className="testimonial__inner-2">
                                                            <h2 className="testimonial__title-2">Sacesta</h2>
                                                            <p className="testimonial__text-2">Sumit and his team at Sacesta Technologies demonstrated outstanding professionalism and patience in our project. Their ability to swiftly resolve bugs and maintain high standards of work has led us to award them a full-time project. The dedication shown by Sumit and Uday has been remarkable.</p>
                                                            <h3 className="testimonial__author">Shekhar Sagar</h3>
                                                            <h4 className="testimonial__role">Director at GetGrahak</h4>
                                                        </div>
                                                    </div>

                                                    <div className="swiper-slide testimonial__slide">
                                                        <div className="testimonial__inner-2">
                                                            <h2 className="testimonial__title-2">Sacesta</h2>
                                                            <p className="testimonial__text-2">Delivered exceptional work exactly as anticipated. The project was completed to the highest standards, meeting all our expectations. Excellent job!</p>
                                                            <h3 className="testimonial__author">Lokesh P.</h3>
                                                            <h4 className="testimonial__role">CTO At Paperpal</h4>
                                                        </div>
                                                    </div>

                                                    <div className="swiper-slide testimonial__slide">
                                                        <div className="testimonial__inner-2">
                                                            <h2 className="testimonial__title-2">Sacesta</h2>
                                                            <p className="testimonial__text-2">Exceptionally talented development team, highly recommended for their expertise and skill. Outstanding service!</p>
                                                            <h3 className="testimonial__author">Eduardo M.</h3>
                                                            <h4 className="testimonial__role">From Mexico</h4>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>

                                            <div className="testimonial__pagination">
                                                <div className="prev-button"><i className="fa-solid fa-arrow-right"></i></div>
                                                <div className="next-button"><i className="fa-solid fa-arrow-left"></i></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                        {/* <!-- Testimonial area end --> */}


                        {/* <!-- CTA area start --> */}
                        <section className="cta__area">
                            <div className="container line pb-110 dark-p">
                                <div className="line-3"></div>
                                <div className="row">
                                    <div className="col-xxl-12">
                                        <div className="cta__content">
                                            <p className="cta__sub-title">Work with us</p>
                                            <h2 className="cta__title title-anim">We're eager to learn more about your project.</h2>
                                            <div className="btn_wrapper">
                                                <a href="https://calendly.com/sacesta/30min"
                                                    className="wc-btn-primary btn-hover btn-item"><span></span>Let’s talk us <i
                                                        className="fa-solid fa-arrow-right"></i></a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                        {/* <!-- CTA area end --> */}

                    </main>



                    {/* <!-- Footer area start --> */}
                    {/* <?php include "includes/footer.php"; ?> */}
                    <Footer />

                </div>
            </div>

        </>
    )
}

export default About